import { createContext, useEffect, useState, PropsWithChildren } from 'react';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { Spinner } from '../components/spinner/spinner';
import { usePaymentApiV1 } from '../clients/quipli-service/payment/payment-api-v1';

export const StripeContext = createContext<Promise<Stripe | null>>(new Promise(() => null));

export const StripeContextProvider = ({ children }: PropsWithChildren) => {
  const { getStripeSettings } = usePaymentApiV1();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [stripe, setStripe] = useState<Promise<Stripe | null>>(new Promise(() => null));

  useEffect(() => {
    getStripeSettings().then((settings) => {
      setStripe(
        loadStripe(settings.publishableKey, {
          stripeAccount: settings.accountType !== 'custom' ? settings.connectedAccountId : undefined,
        }),
      );
      setIsLoading(false);
    });
  }, []);

  return !isLoading ? <StripeContext.Provider value={stripe}>{children}</StripeContext.Provider> : <Spinner />;
};
